import {
  CalculationUserJourneyMode,
  DriverCostCalculationType,
  LeasingCostCalculationType,
  PlanrLineSchedule,
  ProductionCostValidationErrors,
  ProductionCostFilterType,
  ProductionCostState
} from './types';

export const getInitLineSchedule: () => PlanrLineSchedule = () => ({
  // used only on the FE side for updating store, as a key, etc
  lineScheduleKey: Math.random(),
  isValid: false,
  toggle: true,
  lineNumber: null,
  lineUuid: null,
  scheduleStatus: null,
  scheduleType: null,
  scheduleWorkflowType: null,
  schedules: [],
  productionCostBuses: null
});

export const productionCostsInitialValidationErrorsState: ProductionCostValidationErrors =
  {
    busValues: {},
    busScheduleValues: {}
  };

export const productionCostsInitialState: ProductionCostState = {
  id: null,
  name: null,
  startDate: null,
  endDate: null,
  status: null,
  origin: null,
  actionType: null,
  costYear: null,
  lines: [],
  linesLoading: false,
  lineSchedules: [getInitLineSchedule()],
  productionCostBuses: null,
  countryDriverConceptTypes: {},
  vehicleTypeCostEntries: {},
  busPartnerAndCountryDriverCostEntry: {},
  driverShiftsCalculationTypeAllowed: true,
  busValues: null,
  busScheduleValues: null,
  calculatedProductionCosts: null,
  loading: false,
  driverCostCalculationType: DriverCostCalculationType.DriverScheduleHours,
  leasingCostCalculationType: LeasingCostCalculationType.Standard,
  calculationUserJourneyMode: CalculationUserJourneyMode.CreateCalculation,
  planrBusPartners: [],
  planrDataVersion: '2', // "1" - rides-based calculation, otherwise - trips-based calculation
  filteredPlanrBusPartnerIds: [],
  planrVehicles: [],
  filteredPlanrVehicleIds: [],
  filterType: ProductionCostFilterType.AllVehicles,
  released: null,
  validationErrors: productionCostsInitialValidationErrorsState,
  serverErrors: {}
};
